export const EDITOR_IMAGE_MIME_TYPES = [
  'image/apng',
  'image/avif',
  'image/gif',
  'image/heic',
  'image/heif',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/tiff',
  'image/webp',
];

export const isEditorCompatibleImage = (file: File | DataTransferItem) =>
  EDITOR_IMAGE_MIME_TYPES.includes(file.type);
